import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer, EuiButton } from '@elastic/eui';
import UnboxingCard from 'components/Outdoor_Cameras/IN-7011_HD/Usermanual/YoutubeVideoCard';
import YoutubeCards from 'components/Outdoor_Cameras/IN-7011_HD/Usermanual/YoutubeVideoCards';
import NavButtons from 'components/Outdoor_Cameras/IN-7011_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  EuiButton,
  UnboxingCard,
  YoutubeCards,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};